import { StyleSheet } from "react-native";
import { Theme } from "@sodraberget/shared";

const sideBarContentStyle = (theme: Theme) => StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'column',
        backgroundColor: theme.color.listBackground,
    },

    brightContainer: {
        flex: 1,
        flexDirection: 'column',
        backgroundColor: theme.color.listEntryBackground,
    },

    list: {
        flex: 1,
    },

    marginTop: {
        marginTop: theme.spacing.standard,
    },

    marginBottom: {
        marginBottom: theme.spacing.standard,
    },

    standard: {
        fontSize: theme.fontSize.standard,
    },

    pathChildRow: {
        marginLeft: 16,
        borderLeftWidth: 2,
        borderLeftColor: theme.color.textSecondary,
        paddingLeft: 8,
    },

    pathCompositeFooter: {
        position: 'absolute',
        bottom: -2,
        left: 0,
        right: 0,
        alignItems: 'center',
    },

    pathExpandButton: {
        width: 16,
        height: 12,
        borderRadius: 3,
        backgroundColor: theme.color.textLink,
        alignItems: 'center',
        justifyContent: 'center',
    },

    pathExpandIcon: {
        width: 10,
        height: 10,
        color: theme.color.textInverted,
    },
});

export { sideBarContentStyle };